import { Drawer, useTheme } from '@mui/material';
import DrawerContent from './content/DrawerContent.tsx';
import { useStore } from '../../store/store.ts';
import { Logo } from '../header/Logo.tsx';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

function MiniDrawer(props: { open: boolean }) {
  const toggleDrawer = useStore().toggleDrawer;
  const theme = useTheme();
  return (
    <Drawer sx={{ zIndex: theme.zIndex.drawer + 2 }} open={props.open} variant="temporary" onClose={toggleDrawer}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          paddingInline: '16px',
        }}
      >
        <IconButton onClick={toggleDrawer} aria-label="close">
          <MenuIcon />
        </IconButton>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flex: 1,
          }}
        >
          <Logo />
        </div>
      </div>
      <DrawerContent />
    </Drawer>
  );
}

export default MiniDrawer;
